// extracted by mini-css-extract-plugin
module.exports = {"global":"index_global__70uuF","titleAll":"index_titleAll__e7b9e","yellow":"index_yellow__N4V9g","desBOX":"index_desBOX__qYef9","desBox":"index_desBOX__qYef9"};